// extracted by mini-css-extract-plugin
export default {"noResults":"NoResultsFound_noResults__vInrH","noResultsImage":"NoResultsFound_noResultsImage__h0UFh"};